import * as React from 'react';

type Size = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";

interface IProps {
    name: string,
    size: Size,
    infinite: boolean,
}

const SIZE_MAP = {
    sm: 'small',
    md: '',
    lg: 'fa-2x',
    xl: 'fa-4x',
    xxl: 'fa-5x',
}

export default class LoadingCircle extends React.Component<IProps, {}> {
    render() {
        const classNames = [
            "fa", "fa-circle-o-notch", "fa-spin", "fa-fw", "text-info"
        ];

        let { name, size, infinite } = this.props;

        size = size || 'md';
        infinite = infinite || false;

        classNames.push(SIZE_MAP[size]);

        return (
            <div className="text-center">
                <i className={classNames.join(' ')} />
                <pre className="se-4backend-loading" style={{ "display": "none" } as React.CSSProperties}>{name}</pre>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/loading/Circle.tsx